
import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import Modal from 'react-bootstrap/Modal'
import { Query } from 'Utilities/incognitaAPI'
import CSRFToken from 'UI/CSRFToken'
import Select from 'UI/Select'
import Form from 'react-bootstrap/Form';
import FontAwesomeIcon from 'UI/FontAwesomeIcon'

const GET_OPTIONS = `
  query importConfigurationReportCreateOptions($id: ID!) {
    importConfigurationReportCreateOptions(id: $id) {
      clients {
        label,
        value
      },
      locations {
        label,
        value
      },
      types {
        label,
        value
      },
      sources {
        label,
        value
      },
      recurrences {
        label,
        value
      },
      fileNameRegex,
      associatedImportAudits {
        id,
        importFileName
      }
    }
  }
`

const CreatePopup = ({ importConfiguration, setImportConfiguration }) => {
  const [loading, setLoading] = useState(true)

  const [fileNameRegex, setFileNameRegex] = useState(null)
  const [options, setOptions] = useState({})

  const handleClose = () => setImportConfiguration(null)

  const fetchOptions = () => {
    if (!importConfiguration) return

    setLoading(true)

    Query(GET_OPTIONS, { id: importConfiguration.id })
      .then(res => setOptions(res.importConfigurationReportCreateOptions))
      .finally(() => setLoading(false))
  }

  useEffect(fetchOptions, [importConfiguration])

  return (
    <div
      className="modal show"
      style={{ display: 'block', position: 'initial' }}
    >
      <Modal show={importConfiguration} onHide={handleClose}>
        {loading && (
          <div className="absolute z-50 bg-white opacity-80 flex items-center justify-center h-full w-full">
            <FontAwesomeIcon
              className="animate-spin text-5xl text-blue-600"
              icon="spinner"
            />
          </div>
        )}

        <form action={`/system/import_configurations`} method="POST">
        <CSRFToken />
        <input type="hidden" name="import_configuration[resource]" value={importConfiguration?.resource} />
        <input type="hidden" name="import_configuration[target_table]" value={importConfiguration?.targetTable} />
        <input type="hidden" name="import_configuration[import_type]" value="File" />

        <Modal.Header closeButton>
          <Modal.Title>Create Import Configuration</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="leading-none mb-1 text-gray-600">File Name Regex</div>
          <Form.Control
            className="mb-2"
            type="text"
            name="import_configuration[file_name_regex]"
            value={fileNameRegex}
            onChange={e => setFileNameRegex(e.target.value)}
            isRequired
          />

          <div className="leading-none mb-1 text-gray-600">Location</div>
          <Select
            name="import_configuration[source_location]"
            className="mb-2"
            options={options.locations}
            required
          />

          <div className="leading-none mb-1 text-gray-600">Client</div>
          <Select
            className="mb-2"
            name="import_configuration[viaje_client_id]"
            options={options.clients}
          />

          <div className="leading-none mb-1 text-gray-600">Type</div>
          <Select
            className="mb-2"
            name="import_configuration[type]"
            options={options.types}
          />

          <div className="leading-none mb-1 text-gray-600">Source</div>
          <Select
            className="mb-2"
            name="import_configuration[source]"
            options={options.sources}
          />

          <div className="leading-none mb-1 text-gray-600">Recurrence</div>
          <Select
            className="mb-2"
            name="import_configuration[recurrence]"
            options={options.recurrences}
          />

          <div className="mt-6 text-lg font-medium text-gray-800">
            Associated Files
          </div>

          <div className="text-gray-600 mb-1">
            Check all associated files to assign them to new import configuration.
          </div>

          <div className="h-48 overflow-y-scroll p-1">
            {options.associatedImportAudits?.map(item => (
              <div className={`flex py-1 border-b font-medium items-center ${item.importFileName.match(fileNameRegex) ? 'text-green-600' : 'text-red-600'}`}>
                <FontAwesomeIcon className="w-6 text-lg" icon={item.importFileName.match(fileNameRegex) && 'check'} />

                {item.importFileName}
              </div>
            ))}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="outline-danger" onClick={handleClose}>
            Discard
          </Button>
          

          <Button type="submit" variant="primary">
            Create
          </Button>
        </Modal.Footer>
      </form>
      </Modal>
    </div>
  )
}
export default CreatePopup
